// extracted by mini-css-extract-plugin
export var black = "_u-6";
export var brand = "_u-1";
export var ddefault = "_u-0";
export var error = "_u-3";
export var gray = "_u-2";
export var highContrast = "_u-8";
export var outline = "_u-7";
export var success = "_u-5";
export var warning = "_u-4";